import * as w from '../../../services/webhook';
import * as c from '../services/config';
import { ActionTypes } from '../types/action-types';
import { IConstantRequestMap, IRequestConfigMap } from '../types/config';
import * as a from './app';

export const loadConfig = (accessToken: string, tenantId: string) => async dispatch => {
    const config = await c.getConfig(accessToken, tenantId)
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
}

export const installSchema = (accessToken: string, tenantId: string, enable: boolean) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        enabled: enable
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
    if (!config.enabled) {
        dispatch(a.expandConfigView(false));
        dispatch(a.expandBYODView(false));
    }
};

export const saveEnvironment = (accessToken: string, tenantId: string, environment: string) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        environment,
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};

export const saveMappings = (accessToken: string, tenantId: string, mappings: IRequestConfigMap) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        mappings
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};

export const saveConstants = (accessToken: string, tenantId: string, constants: IConstantRequestMap) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        constants
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};

export const generateWebhook = (accessToken: string, tenantId: string) => async dispatch => {
    const id = await w.generateWebhook(accessToken, tenantId)
    const config = await c.updateConfig(accessToken, tenantId, {
        webhook: id
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};



// WEBPACK FOOTER //
// ./src/sub-projects/codat/actions/config.ts